import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
const _excluded = ["illustrationType", "title", "description", "action", "footer", "onLogout", "style"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { PublicPageLayout } from '@adsk/alloy-project-page-layout';
import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
export const DefaultAction = _ref => {
  let {
    onRetry = () => window.location.reload()
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("./i18n/".concat(locale, ".json"));
  });
  return /*#__PURE__*/React.createElement(LinkButton, {
    onClick: () => onRetry === null || onRetry === void 0 ? void 0 : onRetry()
  }, T.translate('TRY_AGAIN'));
};
/**
 * An ErrorPage component. Used to show a generic error page when no other option exists.
 * Can be used as a fallback when using a page level ErrorBoundary for example.
 */
const ErrorPage = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
      illustrationType = EmptyState.ILLUSTRATION_TYPES.BUILDING_CONSTRUCTION_GREY,
      title,
      description,
      action,
      footer,
      onLogout,
      style
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded);
  const {
    T
  } = useLocale(_ref4 => {
    let {
      locale
    } = _ref4;
    return require("./i18n/".concat(locale, ".json"));
  });
  const finalTitle = title || T.translate('ERROR_PAGE_TITLE');
  const finalDescription = description || T.translate('ERROR_PAGE_DESCRIPTION');
  const finalAction = action || /*#__PURE__*/React.createElement(DefaultAction, null);
  return /*#__PURE__*/React.createElement(PublicPageLayout, {
    onLogout: onLogout,
    ref: ref
  }, /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, props, {
    $_css: [{
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      height: '100%',
      justifyContent: 'center'
    }, style]
  }), /*#__PURE__*/React.createElement(EmptyState, {
    title: finalTitle,
    illustrationType: illustrationType,
    description: finalDescription,
    size: EmptyState.SIZES.LARGE
  }, /*#__PURE__*/React.createElement(React.Fragment, null, finalAction && /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [theme.typography.heading2]
  }, finalAction), footer && /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css3: [_objectSpread({
      marginTop: 72,
      color: theme.colors.charcoal700
    }, theme.typography.bodyLargeBold)]
  }, footer)))));
});
ErrorPage.displayName = 'ErrorPage';
ErrorPage.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Illustration type */
  illustrationType: PropTypes.oneOf(Object.values(EmptyState.ILLUSTRATION_TYPES)),
  /** Error page title */
  title: PropTypes.node,
  /** Error page description */
  description: PropTypes.node,
  /** Error page action */
  action: PropTypes.node,
  /** Error page footer */
  footer: PropTypes.node,
  /** callback called on logout */
  onLogout: PropTypes.func
};
export default Object.assign(ErrorPage, {
  ILLUSTRATION_TYPES: EmptyState.ILLUSTRATION_TYPES
});
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), p => p.$_css);
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), p => p.$_css2);
var _StyledDiv3 = _styled3("div").withConfig({
  displayName: "ErrorPage___StyledDiv3",
  componentId: "sc-1ioo1uv-0"
})(["", ""], p => p.$_css3);
//# sourceMappingURL=ErrorPage.js.map